const isNewArticle = (difference: number) => {
  return difference > -7 ? true : false
}

export default isNewArticle
